var exports = {
  "x6": "MemberListItem.module__button___S2VWek",
  "OG": "MemberListItem.module__nameRoleColored___S2VWek",
  "w1": "MemberListItem.module__buttonOffline___S2VWek",
  "dP": "MemberListItem.module__buttonContextMenuOpen___S2VWek",
  "vs": "MemberListItem.module__memberFocusRing___S2VWek",
  "Vg": "MemberListItem.module__grid___S2VWek",
  "Qs": "MemberListItem.module__content___S2VWek",
  "H": "MemberListItem.module__avatarContainer___S2VWek",
  "TT": "MemberListItem.module__userInfoContainer___S2VWek",
  "VW": "MemberListItem.module__nameContainer___S2VWek",
  "UU": "MemberListItem.module__name___S2VWek",
  "w4": "MemberListItem.module__memberCustomStatus___S2VWek",
  "Dd": "MemberListItem.module__ownerIcon___S2VWek",
  "j$": "MemberListItem.module__crownIcon___S2VWek",
  "a1": "MemberListItem.module__userTag___S2VWek",
};

module.exports = exports;
